<template>
  <div class="casus">
    <div class="swiper-container swiper-casus">
      <!-- Additional required wrapper -->
      <div class="swiper-wrapper">
        <!-- Slides page1 -->
        <!-- <div class="swiper-slide">
          <div class="swiper_title">客户案例</div>
          <div class="swiper_box">
            <div class="text_quotes">
              <img src="../../assets/img/quotes.png" alt="">
            </div>
            <div class="text_content">
              易招聘作为一款人事招聘管理的应用和背调工具，公司的人事部门自使用后，极大地提高了工作效率和工作质量。
            </div>
            <div class="text_content">
              该应用贯穿了日常工作的整个业务流程-订立招聘岗位计划、候选人简历入库、发起面试邀约、背调、发送offer，而且可以清楚看见每位候选人目前进入了招聘的哪一状态，从而帮助我们的HR进一步规范工作流，推进招聘工作进度。
            </div>
            <div class="inscribe">-雅戈尔集团股份有限公司</div>
          </div>
        </div> -->
        <div class="swiper-slide">
          <div class="swiper_title">客户案例</div>
          <div class="swiper_box">
            <div class="text_quotes">
              <img src="../../assets/img/quotes.png" alt="">
            </div>
            <div class="text_content">
              自从用了易招聘，为公司人力管理节省了极大的开支并极大地提高了效率！易招聘轻应用能很清晰的查询到面试流程，并对人才储备也能很好的管理，比较符合我司的刚需。
            </div>
            <div class="text_content">
              可以预见，在未来的一年里，有了易招聘，招聘就有了一个大管家，公司的业务将会因他而逾增风采！
            </div>
            <div class="inscribe">-上海璞康实业有限公司</div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="swiper_title">客户案例</div>
          <div class="swiper_box">
            <div class="text_quotes">
              <img src="../../assets/img/quotes.png" alt="">
            </div>
            <div class="text_content">
              自从用了易招聘，为公司人力管理节省了极大的开支并极大地提高了效率！易招聘轻应用能很清晰的查询到面试流程，并对人才储备也能很好的管理，比较符合我司的刚需。
            </div>
            <div class="text_content">
              可以预见，在未来的一年里，有了易招聘，招聘就有了一个大管家，公司的业务将会因他而逾增风采！
            </div>
            <div class="inscribe">-上海璞康实业有限公司</div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="swiper_title">客户案例</div>
          <div class="swiper_box">
            <div class="text_quotes">
              <img src="../../assets/img/quotes.png" alt="">
            </div>
            <div class="text_content">
              易招聘是一个使用起来非常流畅的人事软件，招聘专员可以直接看到各个招聘平台的邀约情况，招聘经理可以清晰的了解招聘进度，极大的方便了日常的工作，操作也很容易上手，学习成本很低，总的来说，还是非常适合符合我们公司的诉求。
            </div>
            <!-- <div class="text_content">
              该应用贯穿了日常工作的整个业务流程-订立招聘岗位计划、候选人简历入库、发起面试邀约、背调、发送offer，而且可以清楚看见每位候选人目前进入了招聘的哪一状态，从而帮助我们的HR进一步规范工作流，推进招聘工作进度。
            </div> -->
            <div class="inscribe">-浙江青莲食品股份有限公司</div>
          </div>
        </div>
      </div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper';
export default {
  data() {
    return {
      mySwiper: {},
    };
  },
  mounted: function() {
    this.$store.dispatch("first_nav_change", "4");
    this.initSwiper();
  },
  computed: {},
  methods: {
    initSwiper() {
      this.mySwiper = new Swiper(".swiper-casus", {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        loop: true,
      });
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/casus.vue